export { requestAjax } from './requestAjax';
export { instance } from './instance';
